import "../styles/Billy.css";

const features = [
  "Splits token spend across the phases of building software: understand, design, build, test, review, ops",
  "Measures efficiency, not volume: how spend is distributed across the work, not just how much",
  "Instruments where Claude Code runs, the richest telemetry surface, per step and per tool",
  "Local and private by design: an efficiency coach, not a surveillance dashboard",
  "A leading indicator of hidden waste, catching rework before the invoice",
  "FinOps for AI, built for the moment token bills became a naked line on the invoice",
];

function Billy() {
  return (
    <main className="ix-page">
      <header className="ix-hero center">
        <div className="ix-shell">
          <span className="ix-eyebrow">FinOps for AI · In development</span>
          <h1 className="by-title">Bill-y</h1>
          <p className="by-pron">pronounced Bil Li</p>
          <p className="ix-hero-lead by-tagline">
            Measuring not how much AI your team uses, but how well.
          </p>
        </div>
      </header>

      <section className="ix-section">
        <div className="ix-shell">
          <p className="by-desc">
            Bill-y is a monitoring layer that splits an engineering team&rsquo;s AI
            token spend across the phases of building software, so leaders can see
            whether AI is being used efficiently, not merely heavily. In the token
            maxxing era, volume is the new lines of code: easy to game, and generated
            for free by the very tool being measured. Bill-y measures the distribution
            instead, a leading indicator of the hidden waste that otherwise surfaces
            only when the invoice arrives.
          </p>

          <div className="ix-sec-head" style={{ marginTop: "48px", marginBottom: "24px" }}>
            <span className="ix-eyebrow is-gray">What Bill-y does</span>
          </div>
          <div className="ix-grid-2">
            {features.map((f) => (
              <div className="ix-card by-feature" key={f}>
                <span className="pr-feature-dot" aria-hidden="true" />
                <span>{f}</span>
              </div>
            ))}
          </div>

        </div>
      </section>
    </main>
  );
}

export default Billy;
